import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-19/task-03";

const task: Slide = {
  titleHtml: "Which one of these floor structures will provide</br>the best protection from impact noise?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
